var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner",staticStyle:{"margin-bottom":"80px"}},[_c('el-container',[_c('el-aside',{attrs:{"width":"1.8rem"}},[_c('layout-left')],1),_vm._v(" "),_c('el-main',[_c('router-view',{key:_vm.$route.path})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b47b32c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personalcenter/personalDetails.vue
// module id = null
// module chunks = 